<template>
        <div class="footer-container">
            <div class="footer-contact">
                <div class="contact-tel" @click="callPhone">
                    <img src="@/mobile/assets/footer/tel.png" alt="">
                    {{$t('h.fr1_1')}}
                </div>
                <div class="contact-email" @click="emailClick">
                    <img src="@/mobile/assets/footer/email.png" alt="">{{$t('h.fr1_2')}}
                </div>
            </div>
            <div class="footer-contactImg">
                <img src="@/mobile/assets/footer/wx.png" alt="">
                <img src="@/mobile/assets/footer/qq.png" alt="">
                <img src="@/mobile/assets/footer/face.png" alt="">
                <img src="@/mobile/assets/footer/in.png" alt="">
            </div>
            <div class="footer-copyright">
                <div class="address" @click="clickcontactus">
                    <div>{{$t('h.b2l_1')}}</div>
                    <div>{{$t('h.b2l_11')}}</div>
                    <div>{{$t('h.b2l_2')}}</div>
                    <div>{{$t('h.b2l_3')}}</div>
                    <div>{{$t('h.b2l_4')}}</div>
                    <div>{{$t('h.b2l_5')}}</div>
                    <div>{{$t('h.b2l_6')}}</div>
                    <div>{{$t('h.b2l_20')}}</div>
                    <div>{{$t('h.b2l_10')}}</div>
                    <!-- <div>{{$t('h.b2l_7')}}</div> -->
                    <!-- <div>{{$t('h.b2l_8')}}</div> -->
                    <!-- <div>{{$t('h.b2l_9')}}</div> -->
                     <!-- <div class="link">
                        <a href="https://beian.miit.gov.cn/" target="_self">{{$t('h.b2l_10')}}</a>
                    </div> -->
                </div>
                <div class="text">© 2012-2026 Honeng Electronics. All rights reserved.</div>
                <div class="logo-explain">
                    <img src="@/mobile/assets/footer/double_logo.png" alt="">
                    <div class="explain" @click="termsClick">{{$t('h.b2r_2')}}</div>
                </div>
            </div>
        </div>
        
</template>
<script>
export default{
    data() {
        return{
            showCode:false,
        }
    },
    methods:{
        callPhone() {
            // 移除空格和连字符，只保留数字和+
            const phoneNumber = this.$t('h.fr1_1')
            
            // 方法1：直接修改location
            window.location.href = `tel:${phoneNumber}`;
            
            // 或者方法2：创建a标签并点击
            // const link = document.createElement('a');
            // link.href = `tel:${phoneNumber}`;
            // link.style.display = 'none';
            // document.body.appendChild(link);
            // link.click();
            // document.body.removeChild(link);
        },
        emailClick() {
            window.open("mailto:sales@honengelec.com", '_blank');
        },  
        mouseenterCode() {
            this.showCode = true
        },
        mouseleaveCode() {
            this.showCode = false
        },
        clickV() {
            localStorage.setItem('activeIndex', 3);
            this.$router.push({name:'vdetails'})
            window.location.reload();
        },
        clickC() {
            localStorage.setItem('activeIndex', 3);
            this.$router.push({name:'cdetails'})
            window.location.reload();
        },
        clickQ() {
            localStorage.setItem('activeIndex', 3);
            this.$router.push({name:'qdetails'})
            window.location.reload();
        },
        clickW() {
            localStorage.setItem('activeIndex', 3);
            this.$router.push({name:'wdetails'})
            window.location.reload();
        },
        checkMoreAboutUs() {
            localStorage.setItem('activeIndex', 1);
            this.$router.push({name:'aboutus'})
            window.location.reload();
        },
        clickaboutabracon() {
            localStorage.setItem('activeIndex', 1);
            this.$router.push({name:'aboutabracon'})
            window.location.reload();
        },
        clicklinkcard() {
            localStorage.setItem('activeIndex', 2);
            this.$router.push({name:'linecard',query: { tip: '1'}})
            window.location.reload();
        },
        clickputBrand() {
            localStorage.setItem('activeIndex', 2);
            this.$router.push({name:'putBrand',query: { tip: '2'}})
            window.location.reload();
        },
        clickapplications(val) {
            localStorage.setItem('activeIndex', 4);
            this.$router.push({name:'applications',query: { title: val}})
            window.location.reload();
        },
        clickjoinus() {
            localStorage.setItem('activeIndex', 1);
            this.$router.push({name:'joinus'})
            window.location.reload();
        },
        clicklinecard() {
            this.$router.push({name:'linecard'})
        },
        clickcontactus() {
            this.$router.push({name:'contactus'})
        },
        termsClick() {
            this.$router.push({name:'terms'})
        },
        globalClick() {
            this.$router.push({name:'GTCS'})
        },
    }
}
</script>
<style lang="scss" scoped>
.footer-container{
    margin: 60px 0 0;
    padding: 0 25px;
    background: #FBFBFB;
    .footer-contact{
        display: flex;
        align-items: center;
        font-weight: 400;
        font-size: 20px;
        color: #333333;
        justify-content: space-between;
        padding: 60px 80px 0;
        .contact-tel{
            display: flex;
            align-items: center;
            img{
                margin-right: 10px;
                width: 25px;
                height: 25px;
            }
        }
        .contact-email{
            display: flex;
            align-items: center;
            cursor: pointer;
            img{
                margin-right: 10px;
                width: 25px;
                height: 25px;
            }
        }
    }
    .footer-contactImg{
        display: flex;
        align-items: center;
        justify-content: center;
        margin: 30px 0 40px;
        img{
            width: 45px;
            height: 45px;
            margin-right: 16px;
            &:last-child{
                margin-right: 0;
            }
        }
    }
    .footer-copyright{
        font-weight: 400;
        font-size: 20px;
        color: #999999;
        border-top: 1px solid #EEEEEE;
        padding: 40px 0 60px;
        .address{
            display: flex;
            align-items: center;
            flex-wrap: wrap;
            justify-content: center;
            div{
                border-right: 1px solid #999999;
                padding:0 10px;
                margin-bottom: 10px;
                &:first-child{
                    padding-left: 0;
                }
                &:last-child{
                    padding-right: 0;
                    border-right: none
                }
                &:hover{
                    cursor: pointer;
                }
            }
            // .link{
            //     a{
            //         text-decoration: none;
            //         color: #0E2E61;
            //     }
            // }
        }
        .text{
            text-align: center;
            margin-top: 10px;
        }
        .logo-explain{
            display: flex;
            align-items: center;
            justify-content: space-between;
            padding: 0 5px;
            margin-top: 54px;
            img{
                width: 420px;
                height: 63px;
            }
            .explain {
                font-weight: 400;
                font-size: 20px;
                color: #999999;
                position: relative;
                bottom: 10px;
                text-align: right;
            }
        }
    }
}

// .allfooter{
//     // width: 1200px;
//     // margin: 0 auto;
//     .f_top{
//         display: flex;
//         align-items: flex-start;
//         justify-content: space-between;
//         font-weight: 500;
//         font-size: 16px;
//         color: #333333;
//         line-height: 36px;
//         padding: 40px 0 30px;
//         .t_logo{
//             display: flex;
//             flex-direction: column;
//             .img_hn{
//                 width: 226px;
//                 height: 69px;
//             }
//             .img_et{
//                 width: 202px;
//                 height: 45px;
//                 margin-top: 30px;
//             }
//         }
//         .t_left{
//             display: flex;
//             align-items: flex-start;
//             .left{
//                 margin-right: 50px;
//                 div:hover{
//                     color: #0E2E61;
//                     cursor: pointer;
//                 }
//             }
//         }
//         .t_right{
//             .right{
//                 display: flex;
//                 align-items: center;
//                 img{
//                     width: 25px;
//                     height: 25px;
//                     margin-right: 5px;
//                 }
//             }
//             .right2{
//                 display: flex;
//                 align-items: center;
//                 margin: 10px 0 20px 0;
//                 img{
//                     width: 25px;
//                     height: 25px;
//                     margin-right: 5px;
//                 }
//             }
//             a{
//                 text-decoration: none;
//                 color: #333333;
//                 &:hover{
//                     color: #0E2E61;
//                 }
//             }
//             .b1_right{
//                 display: flex;
//                 align-items: center;
//                 .r_code{
//                     width:45px;
//                     height: 45px;
//                     position: relative;
//                     margin-right: 15px;
//                     .code{
//                         width: 155px;
//                         height: 164px;
//                         position: absolute;
//                         bottom: 40px;
//                         left: -58px;
//                     }
//                 }
//                 a {
//                     width:45px;
//                     height: 45px;
//                     margin-right: 15px;
//                 }
//                 img{
//                     width:45px;
//                     height: 45px;
//                 }
//             }
//         }
//     }
//     .f_line{
//         width: 1200px;
//         height: 1px;
//         background: #333333;
//     }
//     .f_bottom_1{
//         display: flex;
//         align-items: center;
//         justify-content: space-between;
//         margin: 60px 0 40px;
//         .b1_left{
//             img{
//                 width: 287px;
//                 height: 88px;
//             }
//         }
//     }
//     .f_bottom_2{
//         font-weight: 400;
//         font-size: 14px;
//         color: #333333;
//         padding:30px 0 20px;
//         .b2_main{
//             display: flex;
//             align-items: flex-start;
//             justify-content: space-between;
//             // margin-bottom: 20px;
//             .b2_left{
//                 display: flex;
//                 align-items: center;
//                 .l_address{
//                     display: flex;
//                     align-items: center;
//                     div{
//                         color: #0E2E61;
//                         border-right: 1px solid #333;
//                         padding:0 10px;
//                         &:first-child{
//                             padding-left: 0;
//                         }
//                         &:hover{
//                             cursor: pointer;
//                         }
//                     }
//                 }
//                 .l_link{
//                     margin-left: 10px;
//                     a{
//                         text-decoration: none;
//                         color: #0E2E61;
//                     }
//                 }
//             }
//             .b2_right{
//                 // display: flex;
//                 // align-items: center;
//                 div{
//                     text-align: right;
//                     color: #0E2E61;
//                     // border-left: 1px solid #333;
//                     padding:0 0 0 10px;
//                     cursor: pointer;
//                     // &:first-child{
//                     //     color: #333;
//                     //     border-left: none;
//                     //     padding-right: 10px;
//                     // }
//                     &:last-child:hover{
//                         cursor: pointer;
//                     }
//                 }
//             }
//         }
        
//     }
// }
</style>